var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 2.5V2.459C14.0529 2.1615 13.0454 2 11.9999 2C6.47694 2 1.99994 6.477 1.99994 12C1.99994 12.3375 2.01794 12.671 2.05044 13H14.9999V2.5Z",
    fill: "#3F51B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.49951H19.59C19.1115 4.94151 18.571 4.44101 17.9815 3.99951H15V5.49951Z",
    fill: "#ECEFF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9495 12.9995H15H2.05048C2.10148 13.5135 2.20198 14.0115 2.32798 14.4995H21.6725C21.798 14.0115 21.8985 13.5135 21.9495 12.9995Z",
    fill: "#ECEFF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1355 18.9995H4.8645C5.428 19.574 6.0635 20.074 6.751 20.4995H17.249C17.9365 20.074 18.572 19.574 19.1355 18.9995Z",
    fill: "#ECEFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1625 15.9995H2.83746C3.06696 16.5245 3.33996 17.026 3.65246 17.4995H20.3475C20.66 17.026 20.9325 16.5245 21.1625 15.9995Z",
    fill: "#ECEFF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.49951H21.358C21.1625 7.97751 20.9275 7.47601 20.6515 6.99951H15V8.49951Z",
    fill: "#ECEFF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.4995H21.975C21.9495 10.9895 21.8985 10.4865 21.7995 9.99951H15V11.4995Z",
    fill: "#ECEFF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.99951H17.982C17.1205 3.35451 16.1565 2.84151 15.1115 2.49951H15V3.99951Z",
    fill: "#F44336"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.99951H20.6515C20.343 6.46651 19.9885 5.96451 19.5905 5.49951H15V6.99951Z",
    fill: "#F44336"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.99951H21.799C21.694 9.48251 21.539 8.98451 21.3575 8.49951H15V9.99951Z",
    fill: "#F44336"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.9995H21.9495C21.982 12.6705 22 12.337 22 11.9995C22 11.8305 21.983 11.666 21.975 11.4995H15V12.9995Z",
    fill: "#F44336"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6719 14.4995H2.32794C2.46094 15.016 2.62744 15.519 2.83794 15.9995H21.1624C21.3724 15.519 21.5389 15.016 21.6719 14.4995Z",
    fill: "#F44336"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3475 17.4995H3.65247C4.00797 18.0385 4.41397 18.5405 4.86447 18.9995H19.136C19.586 18.5405 19.992 18.0385 20.3475 17.4995Z",
    fill: "#F44336"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75098 20.4995C8.27798 21.4445 10.072 21.9995 12 21.9995C13.928 21.9995 15.722 21.4445 17.249 20.4995H6.75098Z",
    fill: "#F44336"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 6.5L5.3575 6.994L5.875 7.072L5.5 7.457L5.59 8L5.125 7.744L4.66 8L4.75 7.457L4.375 7.072L4.8925 6.994L5.125 6.5Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 6.5L7.3575 6.994L7.875 7.072L7.5 7.457L7.59 8L7.125 7.744L6.66 8L6.75 7.457L6.375 7.072L6.8925 6.994L7.125 6.5Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12498 7.74377L3.58998 7.99977L3.49998 7.45677L3.87498 7.07177L3.35748 6.99377L3.35548 6.98877C3.19048 7.27277 3.03898 7.56527 2.90198 7.86627L3.12498 7.74377Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12494 6.5L9.35744 6.994L9.87494 7.072L9.49994 7.457L9.58994 8L9.12494 7.744L8.65994 8L8.74994 7.457L8.37494 7.072L8.89244 6.994L9.12494 6.5Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 6.5L11.3575 6.994L11.875 7.072L11.5 7.457L11.59 8L11.125 7.744L10.66 8L10.75 7.457L10.375 7.072L10.8925 6.994L11.125 6.5Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 6.5L13.2324 6.994L13.7499 7.072L13.3749 7.457L13.4649 8L12.9999 7.744L12.5349 8L12.6249 7.457L12.2499 7.072L12.7674 6.994L12.9999 6.5Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 10.5L5.3575 10.994L5.875 11.072L5.5 11.457L5.59 12L5.125 11.744L4.66 12L4.75 11.457L4.375 11.072L4.8925 10.994L5.125 10.5Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 10.5L7.3575 10.994L7.875 11.072L7.5 11.457L7.59 12L7.125 11.744L6.66 12L6.75 11.457L6.375 11.072L6.8925 10.994L7.125 10.5Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12494 10.5L9.35744 10.994L9.87494 11.072L9.49994 11.457L9.58994 12L9.12494 11.744L8.65994 12L8.74994 11.457L8.37494 11.072L8.89244 10.994L9.12494 10.5Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12494 10.5L3.35744 10.994L3.87494 11.072L3.49994 11.457L3.58994 12L3.12494 11.744L2.65994 12L2.74994 11.457L2.37494 11.072L2.89244 10.994L3.12494 10.5Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 10.5L11.3575 10.994L11.875 11.072L11.5 11.457L11.59 12L11.125 11.744L10.66 12L10.75 11.457L10.375 11.072L10.8925 10.994L11.125 10.5Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 10.5L13.2324 10.994L13.7499 11.072L13.3749 11.457L13.4649 12L12.9999 11.744L12.5349 12L12.6249 11.457L12.2499 11.072L12.7674 10.994L12.9999 10.5Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.49951L5.8575 8.99351L6.375 9.07151L6 9.45651L6.09 9.99951L5.625 9.74351L5.16 9.99951L5.25 9.45651L4.875 9.07151L5.3925 8.99351L5.625 8.49951Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62494 8.49951L7.85744 8.99351L8.37494 9.07151L7.99994 9.45651L8.08994 9.99951L7.62494 9.74351L7.15994 9.99951L7.24994 9.45651L6.87494 9.07151L7.39244 8.99351L7.62494 8.49951Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 8.49951L3.8575 8.99351L4.375 9.07151L4 9.45651L4.09 9.99951L3.625 9.74351L3.16 9.99951L3.25 9.45651L2.875 9.07151L3.3925 8.99351L3.625 8.49951Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 8.49951L9.8575 8.99351L10.375 9.07151L10 9.45651L10.09 9.99951L9.625 9.74351L9.16 9.99951L9.25 9.45651L8.875 9.07151L9.3925 8.99351L9.625 8.49951Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 8.49951L11.8575 8.99351L12.375 9.07151L12 9.45651L12.09 9.99951L11.625 9.74351L11.16 9.99951L11.25 9.45651L10.875 9.07151L11.3925 8.99351L11.625 8.49951Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.49951L13.7325 8.99351L14.25 9.07151L13.875 9.45651L13.965 9.99951L13.5 9.74351L13.035 9.99951L13.125 9.45651L12.75 9.07151L13.2675 8.99351L13.5 8.49951Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 4.5L5.8575 4.994L6.375 5.072L6 5.457L6.09 6L5.625 5.744L5.16 6L5.25 5.457L4.875 5.072L5.3925 4.994L5.625 4.5Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62494 4.5L7.85744 4.994L8.37494 5.072L7.99994 5.457L8.08994 6L7.62494 5.744L7.15994 6L7.24994 5.457L6.87494 5.072L7.39244 4.994L7.62494 4.5Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 4.5L9.8575 4.994L10.375 5.072L10 5.457L10.09 6L9.625 5.744L9.16 6L9.25 5.457L8.875 5.072L9.3925 4.994L9.625 4.5Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 4.5L11.8575 4.994L12.375 5.072L12 5.457L12.09 6L11.625 5.744L11.16 6L11.25 5.457L10.875 5.072L11.3925 4.994L11.625 4.5Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.5L13.7325 4.994L14.25 5.072L13.875 5.457L13.965 6L13.5 5.744L13.035 6L13.125 5.457L12.75 5.072L13.2675 4.994L13.5 4.5Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58997 3.99977L7.49997 3.45677L7.87497 3.07177L7.59947 3.03027C7.30497 3.17477 7.01947 3.33327 6.74197 3.50527L6.65997 3.99977L7.12497 3.74377L7.58997 3.99977Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12494 2.49951L9.35744 2.99351L9.87494 3.07151L9.49994 3.45651L9.58994 3.99951L9.12494 3.74351L8.65994 3.99951L8.74994 3.45651L8.37494 3.07151L8.89244 2.99351L9.12494 2.49951Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 2.49951L11.3575 2.99351L11.875 3.07151L11.5 3.45651L11.59 3.99951L11.125 3.74351L10.66 3.99951L10.75 3.45651L10.375 3.07151L10.8925 2.99351L11.125 2.49951Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 2.49951L13.2324 2.99351L13.7499 3.07201L13.3749 3.45701L13.4649 3.99951L12.9999 3.74351L12.5349 3.99951L12.6249 3.45651L12.2499 3.07151L12.7674 2.99351L12.9999 2.49951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaFlag);
export default __webpack_public_path__ + "static/media/usa_flag.b12716ab985c06796381d7709807dc96.svg";
export { ForwardRef as ReactComponent };